'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('FilesListController', [
	'$scope',
	'$rootScope',
	'$stateParams',
	'$modal',
	'EntryMain',
	'FileMain',
	'Utilities',
	function (
		$scope,
		$rootScope,
		$stateParams,
		$modal,
		EntryMain,
		FileMain,
		Utilities
	) {

		$scope.languageId = $stateParams.languageId;
		$scope.groupId = $stateParams.groupId;
		$scope.data = {
			isSafari: false,
			files: {},
			activeFile: undefined
		};

		if ($stateParams.fileName) {
			$scope.data.activeFile = decodeURI($stateParams.fileName);
		}

		// Reference the function so that it can be used in template
		$scope.encodeURI = encodeURI;


		/**
		 * Initializes the list view
		 */
		$scope.initListView = function() {

			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
				$scope.data.isSafari = true;
			}

			$scope.initFiles(true);
		};


		/**
		 * Initializes the files
		 */
		$scope.initFiles = function(forceRefresh) {
			FileMain.getFiles($scope.mobileAppId, $scope.groupId, $scope.languageId, forceRefresh)
				.then(
					function(data) {
						$scope.data.files = data.files;
					}
				)
				.catch(
					function(error) {
						Utilities.showMessage('Problem Loading Files', 'We had a problem loading the files. Please try again or contact our support.', 'error');
					}
				);
		};


		/**
		 * Opens modal to export the given file
		 */
		$scope.exportFile = function ($event, file) {
			$event.preventDefault();
			$event.stopPropagation();

			// By default select only the currently active language
			var selectedLanguages = [$scope.language.name];

			var modalInstance = $modal.open({
				templateUrl: 'modules/mobile-apps/views/export-translations-modal.client.view.html',
				controller: 'ExportTranslationsModalController',
				backdrop: true,
				size: 'md',
				resolve: {
					ModalData: function () {
						return {
							mobileApp: $scope.mobileApp,
							selectedLanguages: selectedLanguages,
							exportFile: file,
							exportLanguageId: $scope.language._id,
							groupId: $scope.groupId
						};
					}
				}
			}).result.catch(function(error) {
				if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
				  throw error;
				}
			});

		};


		/**
		 * Returns if an object is empty
		 */
		$scope.isObjectEmpty = function(inputObject) {
			if (inputObject && Object.keys(inputObject).length) {
				return false;
			}
			return true;
		};


		$scope.$on('entriesChangedSuccess', function () {
			// Load all files new and force refresh
			$scope.initFiles(true);
		});


		$rootScope.$on('$stateChangeSuccess',
			function (event, toState, toParams, fromState, fromParams) {
				if (toState.fileName) {
					$scope.data.activeFile = decodeURI(toState.fileName);
				}
			}
		);

	}
]);
